/* @generated — do not edit. Source: data/swatch-colors.json — run: npm run swatches:generate */

function snoozebabyResolveSwatchAlias(colorName, collectionHandle) {

  const aliases = {"bumblebee orange":{"override":"bumblebee"},"bumblebee white":{"override":"bumblebee","collection":"slaapzakken"}};

  const name = String(colorName || '').trim().toLowerCase();

  let collection = String(collectionHandle || '').trim().toLowerCase();

  const rule = aliases[name];

  if (!rule) return { name, collection };

  return {

    name: String(rule.override || name).toLowerCase(),

    collection: rule.collection ? String(rule.collection).toLowerCase() : collection,

  };

};

window.snoozebabySwatchFallback = "#c9c9c9";

window.snoozebabySwatchHex = {
  "smokey green": "#6e8f91",
  "peach blush": "#f1dcd1",
  "fresh blue": "#7c94ac",
  "stone beige": "#b8b8b5",
  "blue nights": "#636e9c",
  "storm grey": "#5f5c63",
  "toffee brown": "#d27e4c",
  "dark green": "#5e5f5f",
  "cloudy grey": "#938c8f",
  "cherry pink": "#ce916f",
  "mystic mint": "#d3ccc3",
  "hazel brown": "#ad9280",
  "delft blue": "#b9b7b9",
  "delfts blue": "#b9b7b9",
  "desert sand": "#cfb19f",
  "warm brown": "#7f6c62",
  "milky rust": "#d0bcad",
  "toffee lemon": "#c06f4d",
  "milky rust rainbow": "#ece3db",
  "grey melange pinguin": "#b4b1ae",
  "blush springtime": "#ebe2de",
  "dune beige": "#d0ae91",
  "olive green": "#c1c1ae"
};

window.snoozebabySwatchAccentHex = {
  "smokey green": "#c8cdcb",
  "peach blush": "#877b75",
  "fresh blue": "#dfdcdd",
  "stone beige": "#7d7d7c",
  "blue nights": "#1b2442",
  "storm grey": "#dfdee2",
  "toffee brown": "#a23c11",
  "dark green": "#eeedf1",
  "cloudy grey": "#efedf3",
  "cherry pink": "#634635",
  "mystic mint": "#76726d",
  "hazel brown": "#6e5142",
  "delft blue": "#042170",
  "delfts blue": "#ffffff",
  "desert sand": "#63554c",
  "warm brown": "#503c34",
  "milky rust": "#645a53",
  "toffee lemon": "#612d23",
  "milky rust rainbow": "#847f7b",
  "grey melange pinguin": "#343234",
  "blush springtime": "#847f7c",
  "dune beige": "#ffffff",
  "olive green": "#ffffff"
};

window.snoozebabySwatchDual = {
  "dune beige": true,
  "olive green": true
};

window.snoozebabySwatchOverrides = {
  "bumblebee": {
    "default": "#d48f3c",
    "byCollection": {
      "slaapzakken": "#ffffff"
    }
  }
};

window.snoozebabySwatchAccentOverrides = {
  "bumblebee": {
    "default": "#f0ebe1",
    "byCollection": {
      "slaapzakken": "#000000"
    }
  }
};

window.snoozebabySwatchDualOverrides = {
  "bumblebee": {
    "default": true,
    "byCollection": {
      "slaapzakken": true
    }
  }
};



window.snoozebabyGetSwatchHex = function (colorName, collectionHandle) {

  const resolved = snoozebabyResolveSwatchAlias(colorName, collectionHandle);

  const name = resolved.name;

  const collection = resolved.collection;

  const override = window.snoozebabySwatchOverrides[name];

  if (override) {

    if (collection && override.byCollection && override.byCollection[collection]) {

      return override.byCollection[collection];

    }

    if (override.default) return override.default;

  }

  return (window.snoozebabySwatchHex && window.snoozebabySwatchHex[name]) || window.snoozebabySwatchFallback;

};



window.snoozebabyGetSwatchAccentHex = function (colorName, collectionHandle) {

  const resolved = snoozebabyResolveSwatchAlias(colorName, collectionHandle);

  const name = resolved.name;

  const collection = resolved.collection;

  const override = window.snoozebabySwatchAccentOverrides[name];

  if (override) {

    if (collection && override.byCollection && override.byCollection[collection]) {

      return override.byCollection[collection];

    }

    if (override.default) return override.default;

  }

  return (window.snoozebabySwatchAccentHex && window.snoozebabySwatchAccentHex[name]) || '#ffffff';

};



window.snoozebabyApplySwatchStyle = function (element, colorName, collectionHandle) {

  if (!element) return;

  element.style.setProperty('--sb-swatch', window.snoozebabyGetSwatchHex(colorName, collectionHandle));

  element.style.setProperty(

    '--sb-swatch-accent',

    window.snoozebabyGetSwatchAccentHex(colorName, collectionHandle)

  );

};

